export const mockData = {
  couple: {
    partner1: "Aman",
    partner2: "Harshita",
    weddingDate: "12 December 2026",
    domain: "thehahahawedding.com",
    mainQuestion: "Harshita, will you marry me?",
    heroImage: "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/b8kptjkk_8Y3A6025.webp",
  },
  audio: {
    title: "Perfect - Ed Sheeran (Instrumental & Lyrical Melody)",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
  },
  storyChapters: [
    {
      id: "chapter-1",
      title: "The Beginning",
      heading: "Somewhere, it all began…",
      copy: "Somewhere between our first conversations, nervous smiles and the moments we didn’t yet know would become memories, life quietly started writing our story.",
      image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/uyq3ozy2_8Y3A6055.webp",
      caption: "Our very first coffee date where time stood still."
    },
    {
      id: "chapter-2",
      title: "The Everyday Magic",
      heading: "You became my favourite part of every day.",
      copy: "Through dinners, adventures, airport hellos, difficult goodbyes, temple visits, birthday surprises and wonderfully ordinary days—you made every place feel warmer.",
      images: [
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/b8kptjkk_8Y3A6025.webp",
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/uyq3ozy2_8Y3A6055.webp"
      ],
      caption: "From late-night chai runs to airport arrivals."
    },
    {
      id: "chapter-3",
      title: "Why You",
      heading: "Why You...",
      cards: [
        "To choose you, every single day.",
        "To be your safe place, your biggest supporter and your home.",
        "To listen with patience, even when I think I already know the story.",
        "To make you smile and keep you laughing through every day.",
        "To stand beside you through every dream, our happiest moments, detours and difficult days.",
        "To love our families as our own and cherish the life we build together.",
        "To keep falling in love with you and to spend forever proving it."
      ],
      scrapbookPhotos: [
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/uyq3ozy2_8Y3A6055.webp",
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/b8kptjkk_8Y3A6025.webp"
      ]
    },
    {
      id: "chapter-4",
      title: "Our Families",
      heading: "Two people became one big, beautiful family.",
      copy: "Your love didn’t just bring two hearts together. It brought families, laughter, blessings and a whole new meaning to home.",
      familyImages: [
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/lm2dwrnh_8Y3A6031.webp",
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/wc4d8hcp_8Y3A5955.webp",
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/9oah6f4g_AMAN7154.webp",
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/fv0qms43_8Y3A5996.webp",
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/owirjwuo_8Y3A6055.webp"
      ],
      caption: "Blessed with love from both sides of our world."
    },
    {
      id: "chapter-5",
      title: "The Roka",
      heading: "A little piece of forever…",
      copy: "March 28 gave our story another beautiful beginning. Surrounded by everyone we love, forever stopped feeling like a dream and started feeling like our future.",
      image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_forever-starts-here-34/artifacts/vky8s2pr_8Y3A5950.webp",
      caption: "The day our hearts made it official in front of everyone."
    }
  ]
};
